import { render, staticRenderFns } from "./CustomerIngredientUpdate.vue?vue&type=template&id=1cf0393a"
import script from "./CustomerIngredientUpdate.vue?vue&type=script&lang=ts"
export * from "./CustomerIngredientUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports